





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { uuid } from '@/util/uuid';
@Component({
  components: {},
})
export default class AddNode extends Vue {
  @Prop() childNodeP: any;
  visible: any = false;
  addType(type: any) {
    this.visible = false;
    if (type !== 4) {
      let data;
      if (type === 1) {
        data = {
          id: uuid(), // 节点id
          nodeName: '审核人',
          type: 1,
          childNode: this.childNodeP,
          nodeUserList: [], // 审核人列表
          error: true,
          assign: {},
          // settype: 1,
          // selectMode: 0,
          // selectRange: 0,
          // directorLevel: 1,
          // examineMode: 1,
          // noHanderAction: 1,
          // examineEndDirectorLevel: 0,
        };
      } else if (type === 2) {
        data = {
          id: uuid(), // 节点id
          nodeName: '抄送人',
          type: 2,
          // ccSelfSelectFlag: 1,
          childNode: this.childNodeP,
          nodeUserList: [],
          assign: {},
        };
      } else if (type === 3) {
        data = {
          id: uuid(), // 节点id
          nodeName: '办理人',
          type: 3,
          assign: {},
          // ccSelfSelectFlag: 1,
          childNode: this.childNodeP,
          nodeUserList: [],
        };
      }
      this.$emit('update:childNodeP', data);
    } else {
      this.$emit('update:childNodeP', {
        nodeName: '条件判断节点',
        id: uuid(), // 节点id
        type: 4,
        childNode: null,
        conditionNodes: [
          {
            id: uuid(), // 节点id
            nodeName: '条件1',
            // error: true,
            type: 5,
            priorityLevel: 1,
            conditionList: [],
            nodeUserList: [],
            conditionGroups: [],
            childNode: this.childNodeP,
          },
          {
            id: uuid(), // 节点id
            nodeName: '条件2',
            type: 5,
            priorityLevel: 2,
            conditionList: [],
            nodeUserList: [],
            conditionGroups: [],
            childNode: null,
          },
        ],
      });
    }
  }
}
